import { GooglePlaceDoorBase } from 'models/google_place_door'
import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { Tag } from 'models/tags'
import { CompanyDistributor, CompanyGPO } from 'models/companies'

// Extended interface to include root-level DoorProxy fields
export interface GooglePlaceDoorBaseWithProxyFields extends GooglePlaceDoorBase {
  note_count: number
  door_taglist: Tag[]
  door_distributors: CompanyDistributor[]
  door_gpos: CompanyGPO[]
  deal_count: number
}

const GOOGLE_PLACE_DOOR_BASE_COLUMNS = {
  name: {
    header: '{datatypeName} Name',
    group: 'Target Attributes',
  },
  place_url: {
    header: 'Place URL',
    group: 'Target Attributes',
  },
  address: {
    header: 'Address',
    group: 'Target Attributes',
  },
  city: {
    header: 'City',
    group: 'Target Attributes',
  },
  state: {
    header: 'State',
    group: 'Target Attributes',
  },
  country: {
    header: 'Country',
    group: 'Target Attributes',
  },
  latitude: {
    header: 'Latitude',
    group: 'Target Attributes',
  },
  longitude: {
    header: 'Longitude',
    group: 'Target Attributes',
  },
  phone: {
    header: 'Phone',
    group: 'Target Attributes',
  },
  website: {
    header: 'Website',
    group: 'Target Attributes',
  },
  reviews_avg: {
    header: 'Average Rating',
    group: 'Target Attributes',
  },
  reviews_cnt: {
    header: 'Total Reviews',
    group: 'Target Attributes',
  },
  reviews_per_score: {
    header: 'Reviews Per Score',
    group: 'Target Attributes',
  },
  open_hours: {
    header: 'Open Hours',
    group: 'Target Attributes',
  },
  closed_status: {
    header: 'Closed Status',
    group: 'Target Attributes',
  },
  store_type: {
    header: 'Store Type',
    group: 'Target Attributes',
  },
  chain_doors_cnt: {
    header: 'Chain Size',
    group: 'Target Attributes',
  },
  zipcode: {
    header: 'ZIP Code',
    group: 'Target Attributes',
  },
  chain_id: {
    header: 'Firstbite Chain ID',
    group: 'Target Attributes',
  },
  // DoorProxy root-level fields
  note_count: {
    header: 'Notes',
    group: 'Campaigns and Deals',
    tooltipName: 'opps_note_count',
  },
  door_taglist: {
    header: 'Door Tags',
    group: 'Campaigns and Deals',
    tooltipName: 'chain_tags',
  },
  door_distributors: {
    header: 'Door Distributors',
    group: 'Campaigns and Deals',
    tooltipName: 'door_distributors',
  },
  door_gpos: {
    header: 'Door GPOs',
    group: 'Campaigns and Deals',
    tooltipName: 'door_gpos',
  },
  deal_count: {
    header: 'Deals',
    group: 'Campaigns and Deals',
    tooltipName: 'opps_deal_count',
  },
} satisfies Partial<
  Record<keyof GooglePlaceDoorBaseWithProxyFields, DataTypeColumn>
>

export const getGooglePlaceDoorBaseColumns = (datatypeName: string) => {
  return Object.entries(GOOGLE_PLACE_DOOR_BASE_COLUMNS).reduce(
    (acc, [key, value]) => {
      acc[key as keyof GooglePlaceDoorBaseWithProxyFields] = {
        ...value,
        header: value.header.replace('{datatypeName}', datatypeName),
      }
      return acc
    },
    {} as Record<keyof GooglePlaceDoorBaseWithProxyFields, DataTypeColumn>
  )
}
